import React from "react";
import styled from "@emotion/styled";
import World from "@ecologi/assets/icons/ProfileCard/world.svg";
import Carbon from "@ecologi/assets/icons/ProfileCard/co2-cloud.svg";
import Trees from "@ecologi/assets/icons/ProfileCard/trees-2.svg";
import Members from "@ecologi/assets/icons/ProfileCard/members.svg";

export const BackgroundColourMapper = {
  carbon: "#EFB954",
  members: "#bfd3df",
  months: "#6BCBE4",
  trees: "#5BBB89",
};

export const IconWrapper = styled.div<{ type: CardType }>`
  align-items: center;
  background-color: ${(props) => BackgroundColourMapper[props.type]};
  border-radius: 99px;
  display: flex;
  height: 73px;
  justify-content: center;
  margin: auto auto 10px;
  position: relative;
  width: 73px;

  @media ${(props) => props.theme.bp.tabletUp} {
    width: 104px;
    height: 104px;
  }
`;

const WorldIcon = styled(World)`
  @media ${(props) => props.theme.bp.tabletUp} {
    transform: scale(1.3);
  }
`;

const CarbonIcon = styled(Carbon)`
  @media ${(props) => props.theme.bp.tabletUp} {
    transform: scale(1.3);
  }
`;

const TreesIcon = styled(Trees)`
  @media ${(props) => props.theme.bp.tabletUp} {
    transform: scale(1.4);
  }
`;

const MembersIcon = styled(Members)`
  transform: scale(0.5);
`;

export type CardType = "months" | "carbon" | "trees" | "members";

export const IconMapper = {
  carbon: <CarbonIcon />,
  members: <MembersIcon />,
  months: <WorldIcon />,
  trees: <TreesIcon />,
};
